import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import SuSettingsPageUI from './SuSettingsPageUI.js'

class SuSettingsPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      user: null,
      errorList: [],
      storageUsed: '0 KB',
    }
  }

  render() {
    return (
      <SuSettingsPageUI
        context={this.props.context}
        user={this.state.user}
        storageUsed={this.state.storageUsed}
        onDeleteStorage={this.onDeleteStorage}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getUser(context)
    this.getStorage()
  }

  getUser(context) {
    let cacheManager = new CacheManager({
      resource: '/api/user',
      cacheKey: CacheKeys.User(context.session.userId),
      callback: this.getUserCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getUserCallback = (response) => {
    this.setState({errorList: response.errorList, user : response})
  }

  getStorage() {
    let storageUsed = 0;
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        const value = localStorage.getItem(key);
        const itemSize = (key.length + value.length) * 2; // rough estimation
        storageUsed += itemSize;
    }
    this.setState({storageUsed: (storageUsed / 1024).toFixed(2) + ' KB'})
  }

  onDeleteStorage = () => {
    for (let key in localStorage) {
      if (key === 'Session' || key === 'Session:CachedTime' || key === 'ecid')
        continue
      if (localStorage.hasOwnProperty(key))
        localStorage.removeItem(key);
    }
    this.getStorage()
  }

}

export default SuSettingsPageSF
